import gql from 'graphql-tag';

const requestEmailChangeUserMutation = gql`
  mutation RequestEmailChangeUserMutation($email: String!, $password: String!) {
    data: requestEmailChangeUserMutation(email: $email, password: $password) {
      title
      message
    }
  }
`;

export default requestEmailChangeUserMutation;
